if (!customElements.get('added-notification')) {
  const AddedNotification = class extends HTMLElement {
    connectedCallback() {
      this.dismissOthers();
      this.setProductTitle(this.dataset.productTitle);
      this.setItem(this.spItem);
      this.display();
      // SP Buy 3 get 1 (r241): offer progress line from sp-b3g1.js; drops the empty slot when the feature is off.
      // r248: after display(), so the offer's 10s timer (armDismiss) or holdOpen replaces the 6s one, not the reverse.
      const b3g1 = this.querySelector('.added-notification__b3g1');
      if (window.SPB3G1) window.SPB3G1.toast(this);
      else if (b3g1) b3g1.remove();
    }
    setItem(item) {
      const imgBox = this.querySelector('.added-notification__image');
      const meta = this.querySelector('.added-notification__meta');
      if (!item) {
        if (imgBox) imgBox.remove();
        if (meta) meta.remove();
        return;
      }
      const src = item.featured_image && item.featured_image.url ? item.featured_image.url : item.image;
      if (imgBox && src) {
        const img = document.createElement('img');
        img.alt = '';
        img.width = 128;
        img.height = 128;
        img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=128';
        imgBox.appendChild(img);
      } else if (imgBox) {
        imgBox.remove();
      }
      if (!meta) return;
      const cents = typeof item.original_price === 'number' ? item.original_price : item.price;
      if (typeof cents === 'number') {
        const price = document.createElement('span');
        price.className = 'added-notification__price';
        const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
        try {
          price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur }).format(cents / 100);
        } catch (e) {
          price.textContent = (cents / 100).toFixed(2);
        }
        meta.appendChild(price);
      }
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      if (variant) {
        if (meta.childNodes.length) {
          const dot = document.createElement('span');
          dot.className = 'added-notification__dot';
          dot.setAttribute('aria-hidden', 'true');
          dot.textContent = '·';
          meta.appendChild(dot);
        }
        const v = document.createElement('span');
        v.className = 'added-notification__variant';
        v.textContent = variant;
        meta.appendChild(v);
      }
      if (!meta.childNodes.length) meta.remove();
    }

    disconnectedCallback() {
      clearTimeout(this.delayedDismissTimeout);
    }

    dismissOthers() {
      document.querySelectorAll('.added-notification').forEach((notification) => {
        if (notification !== this) {
          notification.dismiss();
        }
      });
    }

    setProductTitle(productTitle) {
      this.querySelector('.added-notification__message-title').innerText = productTitle;
    }

    display() {
      setTimeout(() => this.classList.remove('added-notification--hidden'), 10);
      this.armDismiss(6000);
      this.querySelector('.added-notification__close').addEventListener('click', this.dismiss.bind(this));
      if (theme.settings.cartType === 'drawer') {
        const cartLinks = this.querySelectorAll('.added-notification__message-text a[href$="/cart"]');
        cartLinks.forEach((el) => {
          el.addEventListener('click', (evt) => {
            evt.preventDefault();
            document.querySelector('.js-cart-drawer').open(evt.currentTarget);
            this.dismiss();
          });
        });
      }
    }

    // r248: sp-b3g1.js calls these when the toast offers Choose; without them it threw and the offer line never showed
    armDismiss(ms) {
      clearTimeout(this.delayedDismissTimeout);
      this.delayedDismissTimeout = setTimeout(this.dismiss.bind(this), ms);
    }

    // stays until closed (e.g. reached by keyboard, WCAG 2.2.1)
    holdOpen() {
      clearTimeout(this.delayedDismissTimeout);
    }

    dismiss(evt) {
      if (evt) { evt.preventDefault(); }
      this.classList.add('added-notification--dismissed');
      setTimeout(this.remove.bind(this), 2000);
    }
  };

  window.customElements.define('added-notification', AddedNotification);
}
